import React from 'react';

const icon = ({ className = '', ...props }) => (
  <span className={`svg-icon ${className}`} {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
      <path d="M7 13.5A6.5 6.5 0 10.5 7 6.5 6.5 0 007 13.5z" fill="none" stroke="currentColor" />
      <path fill="currentColor" fillRule="evenodd" d="M5.25 10.15v-6.3L10.118 7 5.25 10.15z" />
    </svg>
  </span>
);

export default icon;
